import React from "react";
import { Truck, PartyPopper, Crown } from "lucide-react";

export function FreeDeliveryBar({ subtotal, threshold, club = false, compact = false }) {
  if (!threshold || threshold <= 0) return null;
  const left = Math.max(threshold - subtotal, 0);
  const pct = Math.min(100, Math.round((subtotal / threshold) * 100));
  const done = left <= 0;
  return (
    <div data-testid="free-delivery-bar" className={`border ${done ? "border-neon-green bg-neon-green/10" : "border-zinc-800 bg-ink-surface"} ${compact ? "px-3 py-2" : "p-3"}`}>
      <div className="flex items-center justify-between gap-2 text-xs sm:text-sm">
        <span className={`flex items-center gap-1.5 font-semibold ${done ? "text-neon-green" : "text-zinc-200"}`}>
          {done ? <PartyPopper className="h-4 w-4" /> : <Truck className="h-4 w-4 text-neon-green" />}
          {done ? "Livraison offerte débloquée !" : <>Il te manque <span data-testid="free-delivery-left" className="text-neon-green font-anton text-base">{left.toFixed(2).replace(".00", "")}€</span> pour la livraison offerte</>}
        </span>
        <span className="text-zinc-500 text-[11px] whitespace-nowrap flex items-center gap-1">{club && <Crown className="h-3 w-3 text-neon-magenta" />}dès {threshold}€</span>
      </div>
      <div className="mt-2 h-2 bg-zinc-800 overflow-hidden rounded-full">
        <div data-testid="free-delivery-progress" className={`h-full rounded-full transition-[width] duration-500 ${done ? "bg-neon-green" : "bg-gradient-to-r from-neon-magenta to-neon-green"}`} style={{ width: `${Math.max(pct, 3)}%` }} />
      </div>
    </div>
  );
}
